const extractDomain = () => {
  const isLocalHost = window.location.host.includes('localhost');

  if (isLocalHost) return 'localhost';

  const parts = window.location.host.split('.');
  const domain = `.${parts[parts.length - 2]}.${parts[parts.length - 1]}`;

  return domain;
};

export default extractDomain;
